<template>
  <Row>
    <Col span="24">
        <DatePicker type="daterange" 
        :options="options" 
        placement="bottom-start" 
        placeholder="请选择时间" 
        v-model="seTime"
        class="public-inp"></DatePicker>
        <Select v-model="type" placeholder="请选择类型" class="public-inp">
            <Option value="" >全部</Option>
            <Option v-for="(item,i) in typeList" :value="i+1" :key="i">{{item}}</Option>
        </Select>
        <Button type="primary" icon="md-search" @click="getList()" v-access="'rebateIncome.query'">搜索</Button>
        <Button @click="resetList()" v-access="'rebateIncome.reset'">重置</Button>
    </Col>
    <Col span="24">
        <Table
            :style="{marginTop:'10px'}"
            border
            stripe
            :loading="loading"
            :columns="columns"
            :data="tbList">
            <template slot-scope="{ row,index }" slot="sort">
                <span v-show="false">{{row.code}}</span>
                {{(page-1)*pageSize+index+1}}
            </template>
        </Table>
        <Page 
                :total="total" 
                :page-size="pageSize"
                :current="page"
        show-sizer 
        show-total 
        prev-text="上一页" 
        next-text="下一页" 
        show-elevator 
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
                class="public-page"
        />
    </Col>
  </Row>
</template>
<script>
const columns = [
  {
    title: '序号',
    slot: 'sort',
    width: 60
  },
  {
    title: '门店',
    key: 'retName'
  },
  {
    title: '平台',
    key: 'platformName'
  },
  {
    title: '导入时间',
    key: 'createTime'
  },
  {
    title: '执行时间',
    key: 'auditTime'
  },
  {
    title: '变动金额',
    key: 'amount'
  }
];
//       
const typeList = ['线上支付返利','忠诚度返利','素材转发返利','货架陈列返利','直播福利返利','共享导购返利','待提返利'];
const options = {
                    shortcuts: [
                        {
                            text: '1 week',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: '1 month',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: '3 months',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                };
    export default {
        data () {
            return {
                loading:false,
                options,
                typeList,
                type:'',
                seTime:[],
                columns,
                tbList:[],
                total:0,
                page:1,
                pageSize:10,
            }
        },
        created(){
            this.getList();
        },
        methods: {
            // 列表
            getList(){
                let data = {
                    type:this.type,
                    accType:1,
                    transDirect:0,
                    beginDate:this.initTime(this.seTime,0),
                    endDate:this.initTime(this.seTime,1),
                    page:this.page,
                    pageSize:this.pageSize,
                }
                this.loading = true;
                this.$api.balanceSearch(data).then(res=>{
                    this.loading = false;
                    if(res.code=='200'){
                        this.tbList = res.data;
                        this.total = res.total;
                    }
                })
            },
            initTime(t,i){
                if(!t[i]){ return '' };
                let d = t[i];
                let str = new Date(d);
                return this.tools.formatDate(str);
            },
            // 页码
            pageChange(d){
                this.page = d;
                this.getList();
            },
            // 页数
            pageSizeChange(d){
                this.pageSize = d;
                this.getList();
            },
            // 重置
            resetList(){
                this.seTime=[];
                this.type='';
                this.page = 1;
                this.pageSize = 10;
                this.$nextTick(()=>{
                    this.getList();
                })
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/finance/rebateIncome.vue